import { mediaObjectProvider } from "@/@core/http";
/**
 * TODO remove MediaObject helper functions and use the mediaObjectProvider directly;
 */
export const getFromServer = async (imgId, requestSizes = []) => {
  const response = await mediaObjectProvider.get({ imgId, requestSizes });
  const { contentUrl, sizes } = response;

  return {
    contentUrl,
    sizes,
  };
};
